import { NgModule } from '@angular/core';
import { NgbModule  } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule, DatePipe } from '@angular/common';
import { ToursComponent } from './tours.component';
import { HomeModule } from '../home/home.module';
import { ToursRoutingModule } from './tours-routing.module';
import { DashboardToursComponent } from './dashboard-tours/dashboard-tours.component';
import { HeadToursComponent } from './head-tours/head-tours.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TourReservationComponent } from './tour-reservation/tour-reservation.component';
import { MinibusComponent } from '../admin/minibus/minibus.component';
import { AdminModule } from '../admin/admin.module';
import { TourExcursionComponent } from './tour-excursion/tour-excursion.component';
import { TourItineraryDetailComponent } from './tour-itinerary-detail/tour-itinerary-detail.component';
import { TourPassengersComponent } from './tour-passengers/tour-passengers.component';
import { ModalReservaComponent } from './modal-reserva/modal-reserva.component';
import { ModalReservaConfirmadaComponent } from './modal-reserva-confirmada/modal-reserva-confirmada.component';
import { LoadingBarModule } from '@ngx-loading-bar/core';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';





@NgModule({
  declarations: [
    ToursComponent,
    DashboardToursComponent,
    HeadToursComponent,
    TourReservationComponent,
    TourExcursionComponent,
    TourItineraryDetailComponent,
    TourPassengersComponent,
    ModalReservaComponent,
    ModalReservaConfirmadaComponent,    
  ],
  imports: [
    CommonModule,
    NgbModule,
    ToursRoutingModule,
    HomeModule,
    FormsModule,
    AdminModule,
    ReactiveFormsModule,
    LoadingBarHttpClientModule,
    // for Router use:
    LoadingBarRouterModule,
    // for Core use:
    LoadingBarModule
  ],
  providers: [
    DatePipe
  ]
})
export class ToursModule { }
